"use client";

import React, { useEffect, useState } from "react";
import {
  Card,

  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  TableHead,
  Modal,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from "@mui/material";

import { format } from "date-fns";
import { Link } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';

// Format date
const formatTimeDate = (dateString) => {
  return format(new Date(dateString), "dd MMM yyyy");
};

const BusinessTypeList = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [businessTypes, setBusinessTypes] = useState([]);
 //console.log("businessTypes", businessTypes);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBusinessType, setSelectedBusinessType] = useState(null);
  const [businessType, setBusinessType] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [status, setStatus] = useState(true);
  const [editTitle, setEditTitle] = useState("");
  const [editDescription, setEditDescription] = useState("");
  const [editStatus, setEditStatus] = useState(true);


  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
    setCurrentPage(0);
  };

  const handleEditClick = (businessType) => {
   //console.log("Editing business type:", businessType);

    setSelectedBusinessType(businessType);
    setEditTitle(businessType.businessType);
    setEditDescription(businessType.description);
    setEditStatus(businessType.status);
    setShowEditModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this business type?")) {
      await fetch(`${process.env.REACT_APP_API_URL}/api/admin/saveBusinessType`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ _id: id, isDelete: true }),
      });
    }
  };

  const filteredRows = businessTypes.filter((item) =>
    item.businessType?.toLowerCase().includes(searchQuery.toLowerCase())
  );


  const paginatedRows = filteredRows.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/getall_business_type`);
       //console.log("Fetching business types from API:", response);

        const data = await response.json();
        setBusinessTypes(data);
      } catch (error) {
        console.error("Error fetching business types:", error);
      }
    };

    fetchData();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare form data
    const formData = new FormData();
    formData.append("businessType", businessType);
    formData.append("description", description);
    if (image) formData.append("image", image);

    const res =
      await fetch(`${process.env.REACT_APP_API_URL}/api/admin/saveBusinessType`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          businessType,
          description,
          imageUrl: "",
          status: true
        }),
      });

    if (res.ok) {
      alert("Business type created!");
      setTitle("");
      setDescription("");
      setImage(null);
    } else {
      alert("Error creating business type");
    }
  };

  return (
    <Card sx={{ borderRadius: "7px", mb: 3, p: { xs: 2, sm: 3 } }}>
      <Box
        sx={{
          display: { xs: "block", sm: "flex" },
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <TextField
          variant="outlined"
          size="small"
          placeholder="Search here..."
          value={searchQuery}
          onChange={handleSearchChange}
          sx={{ width: { xs: "100%", sm: "300px" } }}
        />

        <Button
          variant="outlined"
          color="primary"
          size="medium"
          onClick={handleOpen}
          startIcon={<AddIcon />}
          sx={{
            px: { xs: 2, sm: 4 },
            py: 1,
            fontSize: 14,
            fontWeight: 500,
            borderRadius: 2,
            textTransform: "none",
            "&:hover": {
              backgroundColor: "primary.light",
            },
          }}
        >
          Add New Business Type
        </Button>
      </Box>

      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table sx={{ minWidth: 1300 }} aria-label="business table">
          <TableHead className="bg-primary-50">
            <TableRow
              sx={{
                th: {
                  fontWeight: "500",
                  padding: "10px 24px",
                  fontSize: "14px",
                },
              }}
            >
              {/* <TableCell sx={{}} className="text-black border-bottom">#</TableCell> */}
              <TableCell className="text-black border-bottom">ID</TableCell>
              <TableCell className="text-black border-bottom">Business Type</TableCell>
              <TableCell className="text-black border-bottom">Description</TableCell>
              <TableCell className="text-black border-bottom">Created At</TableCell>
              <TableCell className="text-black border-bottom">Status</TableCell>
              <TableCell className="text-black border-bottom">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.length > 0 ? (
              paginatedRows.map((item, index) => (
                <TableRow key={item._id}>
                  <TableCell>#{item._id?.slice(-3)}</TableCell>
                  {/* <TableCell>{item._id}</TableCell> */}
                  <TableCell>{item.businessType}</TableCell>
                  <TableCell>{item.description}</TableCell>
                  <TableCell>{formatTimeDate(item.createdAt)}</TableCell>
                  <TableCell>
                    <Box
                      className={`trezo-badge ${item.status ? "success" : "danger"}`}
                      sx={{ textTransform: "capitalize" }}
                    >
                      {item.status ? "Active" : "Inactive"}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button
                        size="small"
                        variant="text"
                        color="primary"
                        onClick={() => handleEditClick(item)}
                      >
                        Edit
                      </Button>
                      <Button
                        size="small"
                        variant="text"
                        color="error"
                        onClick={() => handleDelete(item._id)}
                      >
                        Delete
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No business types found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                count={filteredRows.length}
                rowsPerPage={rowsPerPage}
                page={currentPage}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage="Rows per page:"
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      {/* Edit Modal */}
      <Modal open={showEditModal} onClose={() => setShowEditModal(false)}>
        <Box
          sx={{
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            mx: "auto",
            mt: "10%",
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" mb={2}>
            Edit Business Type
          </Typography>
          <TextField
            fullWidth
            label="Title"
            value={editTitle}
            onChange={(e) => setEditTitle(e.target.value)}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Description"
            multiline
            value={editDescription}
            onChange={(e) => setEditDescription(e.target.value)}
            margin="normal"
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              value={editStatus ? "active" : "inactive"}
              onChange={(e) => setEditStatus(e.target.value === "active")}
              label="Status"
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>
          <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
            <Button onClick={() => setShowEditModal(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={async () => {
                await fetch(`${process.env.REACT_APP_API_URL}/api/admin/saveBusinessType`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    businessType: editTitle,
                    description: editDescription,
                    status: editStatus,
                    _id: selectedBusinessType._id,
                  }),
                });
                setShowEditModal(false);
                // fetchBusinessTypes();
              }}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      </Modal>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Create Business Type List</DialogTitle>
        <DialogContent>
          <Typography variant="subtitle1" fontWeight="600" mt={1} mb={1}>
            Add A Business Type
          </Typography>

          <TextField
            label="Business Type"
            placeholder="Enter Business Type title"
            fullWidth
            margin="normal"
            value={businessType}
            onChange={(e) => setBusinessType(e.target.value)}
          />

          <TextField
            label="Description"
            placeholder="Type description here..."
            fullWidth
            multiline
            minRows={4}
            margin="normal"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />

          <Box mt={2}>
            <Typography variant="body2" gutterBottom>
              Upload Images
            </Typography>
            <input type="file" onChange={handleFileChange} />
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="error" variant="contained">
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            + Create Business Type
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default BusinessTypeList;
